import * as Yup from "yup";
import artisanSchema from '../artisans/artisansSchema';
import supplierSchema from '../suppliers/suppliersSchema';
import customerSchema from '../customers/customersSchema';
import applicantSchema from '../applicants/applicantsSchema';
import getLangData from "../../../utils/getLangData";


export default (create) =>
  Yup.object().shape({
    firstName: Yup.string()
      .default("")
      .required(getLangData().fields.required),
    lastName: Yup.string()
      .default("")
      .required(getLangData().fields.required),
    picture: Yup.string().default(""),
    email: Yup.string().email()
      .default("")
      .required(getLangData().fields.required),
    phone: Yup.string().default(""),
    address: Yup.string()
      .default("")
      .required(getLangData().fields.required),
    city: Yup.string().default("").required(getLangData().fields.required),
    country: Yup.string()
      .default("egypt"),
      
    // province: Yup.string().default(""),
    zipCode: Yup.string().default(""),
    userType: Yup.array()
      .of(Yup.string())
      .required("Choose one type at least")
      .default([]),
    password: Yup.string()
      .default("").concat(create ? Yup.string().required(getLangData().fields.required).min(5) : null  )
      // .default('').required(getLangData().fields.required).min(5)
      ,

    confirmPassword: Yup.string().oneOf(
      [Yup.ref('password'), null],
      getLangData().general_words.match_password
    ),
    emailVerified: Yup.bool()
      .default(false),
      // .required(getLangData().fields.required),
    status: Yup.bool()
      .default(false)
      // .required(getLangData().fields.required),
      // artisan: values.artisan ? artisanSchema : '',
      // artisan: artisanSchema(),
    // artisan: Yup.object().when('userType',{
    //   is: (value) => value === ["3"],
    //   then: artisanSchema().cast(),
    //   otherwise: null
    // }),
    // supplier: Yup.object().when('supplier',{
    //   is: true,
    //   then:supplierSchema() ,
    // })  ,
    // customer:  Yup.object().when('customer',{
    //   is: true,
    //   then:customerSchema() ,
    // }) ,
    // applicant:  Yup.object().when('applicant',{
    //   is: true,
    //   then: applicantSchema(),
    // }),
  
  });


